import { Tabs, Tab, Card, CardBody } from "@heroui/react";
import { toTitleCase } from "app/utils/fn";
import { IoMdInformationCircleOutline, IoMdStar } from "react-icons/io";
import { MdDescription } from "react-icons/md";
import CommentComponent from "../Comment";
import ProductAboutCard from "../Product/ProductInfoCard";
import { ProductObject } from "app/api/product/product.type";
import { useAtomValue } from "jotai";
import { userAtom } from "app/atoms/user.atom";

interface IProductInfo {
  product: ProductObject;
  selectedKey?: string;
  onSelectionChange?: (key: React.Key) => void;
}

const cardData = ["ABOUT", "DETAILS", "ADDITIONAL INFO"];

export default function ProductInfo({ product, selectedKey, onSelectionChange }: IProductInfo) {
  const user = useAtomValue(userAtom);

  return (
    <>
      <ProductAboutCard
        noCard={true}
        note={
          <Tabs
            aria-label="Product Information"
            fullWidth
            className="p-0 w-full"
            selectedKey={selectedKey}
            onSelectionChange={onSelectionChange}
            classNames={{
              tabList: "bg-zinc-100 dark:bg-zinc-800",
              cursor: "bg-white dark:bg-zinc-700 shadow-sm",
              tabContent: "group-data-[selected=true]:text-primary font-bold",
            }}
          >
            <Tab
              key="Description"
              title={
                <div className="flex items-center gap-2">
                  <MdDescription size={20} /> Description
                </div>
              }
            >
              <Card shadow="none" className="border border-zinc-200 dark:border-zinc-700">
                <CardBody className="bg-white dark:bg-zinc-800 p-6">
                  <div className="prose dark:prose-invert max-w-none">
                    {product?.product?.description ? (
                      <div className="text-base leading-relaxed text-gray-700 dark:text-gray-300">
                        {product.product.description}
                      </div>
                    ) : (
                      <div className="text-gray-500 italic">No description available.</div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Tab>
            <Tab
              key="Details"
              title={
                <div className="flex items-center gap-2">
                  <IoMdInformationCircleOutline size={22} /> Details
                </div>
              }
            >
              <Card shadow="none" className="border border-zinc-200 dark:border-zinc-700">
                <CardBody className="bg-white dark:bg-zinc-800 p-6">
                  <div>
                    {product?.product?.details && product?.product?.details.length > 0 ? (
                      product?.product?.details.map((item: { name: string; detail: string }) => (
                        <div key={item.name} className="mb-4">
                          <div className="font-sans text-lg font-bold">
                            {item.name === "product_packaging_inner"
                              ? "Product packaging"
                              : toTitleCase(item?.name)}{" "}
                          </div>
                          <div className="text-zinc-700 dark:text-zinc-200">{item?.detail}</div>
                        </div>
                      ))
                    ) : (
                      <>No Detail</>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Tab>
            <Tab
              key="Reviews"
              title={
                <div className="flex items-center gap-2">
                  <IoMdStar size={24} className="text-amber-500" /> Reviews
                </div>
              }
            >
              <Card shadow="none" className="border border-zinc-200 dark:border-zinc-700">
                <CardBody className="bg-white dark:bg-zinc-800 p-6">
                  <CommentComponent
                    productId={product?._id}
                    userUid={user?._id as string}
                    accessToken={user?.accessToken as string}
                  />
                </CardBody>
              </Card>
            </Tab>
          </Tabs>
        }
      />
      <ProductAboutCard
        title={cardData[2]}
        note={
          <ol className="list-decimal px-4">
            <li className="mb-4">
              Product stock levels are accurate at the time this webpage was displayed.{" "}
            </li>
            <li className="mb-4">Prices are accurate at the time this webpage was displayed. </li>
            {/* <li className="mb-4">
              Displayed expected delivery dates can change due to circumstances outside our control.
            </li> */}
          </ol>
        }
      />
    </>
  );
}